"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileExtension = exports.basename = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const error_1 = require("./error");
/**
 * Modeled after Python `os.path.basename`
 */
const basename = (path) => {
    return path.split('/').reverse()[0];
};
exports.basename = basename;
const getFileExtension = (path) => {
    const fileExtension = path.split('.').pop();
    (0, error_1.finleyAssert)(finley_types_1.typeguards.isOutputReportFileExtension(fileExtension), `Evaluated unsupported fileExtension [extension:${fileExtension}] [path:${path}]`);
    return fileExtension;
};
exports.getFileExtension = getFileExtension;
//# sourceMappingURL=path.js.map